import { TrendingUp, MessageCircle, Eye } from "lucide-react";

const ParentValueSection = () => (
  <section className="relative py-16 sm:py-20">
    <div aria-hidden className="pointer-events-none absolute -left-32 top-1/3 h-[420px] w-[420px] rounded-full bg-[radial-gradient(circle,rgba(167,139,250,0.18),transparent_60%)] blur-3xl" />
    <div className="container mx-auto px-6 max-w-5xl">
      <div className="grid lg:grid-cols-[0.95fr_1.05fr] gap-10 lg:gap-14 items-center">
        <div>
          <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-violet-300/90 mb-4">
            <span className="h-1.5 w-1.5 rounded-full bg-violet-400 shadow-[0_0_8px_rgba(167,139,250,0.9)]" />
            For parents
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl text-white leading-[1.05]">
            Insight without{" "}
            <span className="bg-gradient-to-r from-violet-200 to-indigo-200 bg-clip-text text-transparent">looking over their shoulder.</span>
          </h2>
          <p className="mt-4 text-white/70 leading-relaxed max-w-md">
            HeirWise quietly surfaces what your teen practiced, where confidence is growing, and the 2-minute talk worth having this week.
          </p>
        </div>

        {/* Parent Insight Pulse */}
        <div className="relative rounded-3xl p-[1px] bg-gradient-to-br from-violet-400/45 to-cyan-400/25 shadow-[0_30px_80px_-30px_rgba(167,139,250,0.55)]">
          <div className="relative rounded-3xl bg-[#0e0d24]/90 backdrop-blur-2xl p-5 sm:p-6 overflow-hidden">
            <div aria-hidden className="absolute -top-12 -right-12 h-44 w-44 rounded-full bg-[radial-gradient(circle,rgba(167,139,250,0.3),transparent_60%)] blur-2xl" />
            <div className="flex items-center justify-between mb-3">
              <div className="text-[10px] uppercase tracking-[0.3em] text-violet-200/85 flex items-center gap-2">
                <Eye className="h-3 w-3" /> Parent Insight Pulse
              </div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-white/40 flex items-center gap-1.5">
                <TrendingUp className="h-3 w-3" /> This week
              </div>
            </div>

            <div className="relative space-y-2">
              {[
                ["Concept", "Borrowing Money"],
                ["Confidence", "Growing"],
                ["Watch area", "Monthly payments vs total cost"],
              ].map(([k, v]) => (
                <div key={k} className="flex items-center justify-between rounded-xl border border-white/8 bg-white/[0.025] px-3.5 py-2.5">
                  <span className="text-[11px] uppercase tracking-[0.22em] text-white/45">{k}</span>
                  <span className="text-[13px] text-white">{v}</span>
                </div>
              ))}

              <div className="rounded-xl border border-violet-300/25 bg-violet-500/[0.08] px-3.5 py-3">
                <div className="text-[10px] uppercase tracking-[0.28em] text-violet-200/85 mb-1 flex items-center gap-1.5">
                  <MessageCircle className="h-3 w-3" /> Conversation starter
                </div>
                <div className="text-[13px] text-white leading-snug">
                  "How would you decide if a loan is worth it?"
                </div>
              </div>
            </div>

            <div className="mt-4 flex items-center gap-1.5">
              {[0, 1, 2, 3, 4].map((i) => (
                <span key={i} className={`h-1.5 flex-1 rounded-full ${i < 3 ? "bg-gradient-to-r from-cyan-400 to-violet-400" : "bg-white/10"}`} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default ParentValueSection;